import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { SurveyPendingDTO } from "@features/bb-formio/dto/form-survey-pending";
import { BooleanFilter, IQueryCommand, NumberFilter } from "@features/filter";
import { IPagedData, PagedCrudService } from "@features/grid";
import { UserHelperService } from "@main/users/user-helper.service";
import { ShareFormDataDTO } from "@main/formio/dto/shareFormDataDTO";

@Injectable()
export class FormioDataViewerService extends PagedCrudService<SurveyPendingDTO> {
    public readonly url = "api/formio-data";
    public readonly entityTitle = "Form data";
    public formDefinitionId: number = -1;
    public isExplorerPage = false;

    //Defines which module instances will be requested
    public categoryId: number = null;

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory, private _userHelperService: UserHelperService) {
        super(http, handlersFactory);
    }

    public extendQueryCommand(queryCommand: IQueryCommand) {
        queryCommand.filters = queryCommand.filters || [];
        queryCommand.filters.push(new NumberFilter("formDefinitionId", this.formDefinitionId));
        if (this.isExplorerPage && this.categoryId == null && this._userHelperService.isTopAdmin) {
            queryCommand.filters.push(new BooleanFilter("isAdmin", true));
        }
    }

    async GetAvailableVersions() {
        return await this.handleRequest<string[]>(
            this.http.get<string[]>(`${this.url}/available-versions`),
            this.handlersFactory.getDefault()
        );
    }

    async DeleteMultiple(idsToDelete: number[]) {
        return await this.handleRequest(
            this.http.delete(`${this.url}/multiple`, {
                params: {
                    idsToDelete: idsToDelete
                }
            }),
            this.handlersFactory.getForDelete(this.entityTitle)
        );
    }

    getPage(queryCommand: IQueryCommand, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<IPagedData<SurveyPendingDTO>> {
        // TODO: Fix this. This filter is applied twice in some cases. Apply the filter only if it is not currently present.
        if (!!this.categoryId) {
            const categoryFilter: NumberFilter = new NumberFilter("formDefinition.formCategoryId", this.categoryId);
            queryCommand.filters ??= [];
            queryCommand.filters.push(categoryFilter);
        }
        return super.getPage(queryCommand, responseHandlerSettings);
    }

    share(formDataId: string, data: ShareFormDataDTO): Promise<void> {
        return this.handleRequest<void>(
            this.http.post<void>(`${this.url}/${formDataId}/share`, data),
            this.handlersFactory.getForUpdate("", { successMessage: "Form PDF has been shared successfully" })
        );
    }
}
